import newCities from 'shared/constants/json/citiesGenAccusative.json';
// noinspection NonAsciiCharacters
export const sity = {
  ...newCities,
  'АР Крым': {
    ru: { genitive: 'Крыму', accusative: 'Крыма' },
    uk: { genitive: 'Криму', accusative: 'Крима' },
  },
  Винница: {
    ru: { genitive: 'Виннице', accusative: 'Винницы' },
    uk: { genitive: 'Вінниці', accusative: 'Вінниці' },
  },
  'Днепр (Днепропетровск)': {
    ru: { genitive: 'Днепропетровске', accusative: 'Днепропетровска' },
    uk: { genitive: 'Дніпропетровську', accusative: 'Дніпропетровська' },
  },
  Донецк: {
    ru: { genitive: 'Донецке', accusative: 'Донецка' },
    uk: { genitive: 'Донецьку', accusative: 'Донецька' },
  },
  Житомир: {
    ru: { genitive: 'Житомире', accusative: 'Житомира' },
    uk: { genitive: 'Житомирі', accusative: 'Житомира' },
  },
  Запорожье: {
    ru: { genitive: 'Запорожье', accusative: 'Запорожья' },
    uk: { genitive: 'Запоріжжі', accusative: 'Запоріжжя' },
  },
  'Ивано-Франковск': {
    ru: { genitive: 'Ивано-Франковске', accusative: 'Ивано-Франковска' },
    uk: { genitive: 'Івано-Франківську', accusative: 'Івано-Франківська' },
  },
  Киев: {
    ru: { genitive: 'Киеве', accusative: 'Киева' },
    uk: { genitive: 'Києві', accusative: 'Києва' },
  },
  'Киевская обл.': {
    ru: { genitive: 'Киевской области', accusative: 'Киевской области' },
    uk: { genitive: 'Київській області', accusative: 'Київської облласті' },
  },
  'Кривой Рог': {
    ru: { genitive: 'Кривом Рогу', accusative: 'Кривого Рога' },
    uk: { genitive: 'Кривому Розі', accusative: 'Кривого Рогу' },
  },
  'Кропивницкий (Кировоград)': {
    ru: { genitive: 'Кропивницком', accusative: 'Кропивницкого' },
    uk: { genitive: 'Кропивницькому', accusative: 'Кропивницького' },
  },
  Луганск: {
    ru: { genitive: 'Луганске', accusative: 'Луганска' },
    uk: { genitive: 'Луганську', accusative: 'Луганська' },
  },
  Луцк: {
    ru: { genitive: 'Луцке', accusative: 'Луцка' },
    uk: { genitive: 'Луцьку', accusative: 'Луцька' },
  },
  Львов: {
    ru: { genitive: 'Львове', accusative: 'Львова' },
    uk: { genitive: 'Львові', accusative: 'Львова' },
  },
  Николаев: {
    ru: { genitive: 'Николаеве', accusative: 'Николаева' },
    uk: { genitive: 'Миколаєві', accusative: 'Миколаїва' },
  },
  Нововолынск: {
    ru: { genitive: 'Нововолынске', accusative: 'Нововолынска' },
    uk: { genitive: 'Нововолинську', accusative: 'Нововолинська' },
  },
  Одесса: {
    ru: { genitive: 'Одессе', accusative: 'Одессы' },
    uk: { genitive: 'Одесі', accusative: 'Одеси' },
  },
  Полтава: {
    ru: { genitive: 'Полтаве', accusative: 'Полтавы' },
    uk: { genitive: 'Полтаві', accusative: 'Полтави' },
  },
  Ровно: {
    ru: { genitive: 'Ровно', accusative: 'Ровно' },
    uk: { genitive: 'Рівному', accusative: 'Рівного' },
  },
  Сумы: {
    ru: { genitive: 'Сумах', accusative: 'Сум' },
    uk: { genitive: 'Сумах', accusative: 'Сум' },
  },
  Тернополь: {
    ru: { genitive: 'Тернополе', accusative: 'Тернополя' },
    uk: { genitive: 'Тернополі', accusative: 'Тернополя' },
  },
  Ужгород: {
    ru: { genitive: 'Ужгороде', accusative: 'Ужгорода' },
    uk: { genitive: 'Ужгороді', accusative: 'Ужгорода' },
  },
  Харьков: {
    ru: { genitive: 'Харькове', accusative: 'Харькова' },
    uk: { genitive: 'Харкові', accusative: 'Харкова' },
  },
  Херсон: {
    ru: { genitive: 'Херсоне', accusative: 'Херсона' },
    uk: { genitive: 'Херсоні', accusative: 'Херсона' },
  },
  Хмельницкий: {
    ru: { genitive: 'Хмельницком', accusative: 'Хмельницкого' },
    uk: { genitive: 'Хмельницькому', accusative: 'Хмельницького' },
  },
  Черкассы: {
    ru: { genitive: 'Черкассах', accusative: 'Черкасс' },
    uk: { genitive: 'Черкасах', accusative: 'Черкас' },
  },
  Чернигов: {
    ru: { genitive: 'Чернигове', accusative: 'Чернигова' },
    uk: { genitive: 'Чернігові', accusative: 'Чернігова' },
  },
  Черновцы: {
    ru: { genitive: 'Черновцах', accusative: 'Черновцов' },
    uk: { genitive: 'Чернівцях', accusative: 'Чернівців' },
  },
  Украина: {
    ru: { genitive: 'Украине', accusative: 'Украины' },
    uk: { genitive: 'Україні', accusative: 'України' },
  },
  Германия: {
    ru: { genitive: 'Германии', accusative: 'Германии' },
    uk: { genitive: 'Німеччині', accusative: 'Німеччини' },
  },
  Польша: {
    ru: { genitive: 'Польше', accusative: 'Польши' },
    uk: { genitive: 'Польщі', accusative: 'Польщі' },
  },
  Чехия: {
    ru: { genitive: 'Чехии', accusative: 'Чехии' },
    uk: { genitive: 'Чехії', accusative: 'Чехії' },
  },
  Литва: {
    ru: { genitive: 'Литве', accusative: 'Литвы' },
    uk: { genitive: 'Литві', accusative: 'Литви' },
  },
  Латвия: {
    ru: { genitive: 'Латвии', accusative: 'Латвии' },
    uk: { genitive: 'Латвії', accusative: 'Латвії' },
  },
  США: {
    ru: { genitive: 'США', accusative: 'США' },
    uk: { genitive: 'США', accusative: 'США' },
  },
};
// noinspection NonAsciiCharacters
export const plural = {
  Мотоцикл: {
    ru: 'Мотоциклы',
    uk: 'Мотоцикли',
  },
};
// noinspection NonAsciiCharacters
export const pluralCrutch = {
  спецтехника: {
    ru: 'Cпецтехнику',
    uk: 'Cпецтехніку',
  },
};
// noinspection NonAsciiCharacters
export const crutch = newCar => ({
  Грузовые: {
    ru: {
      transportTitle: (newCar && 'грузовик') || 'грузовик',
      transportNextTitle: (newCar && 'грузовые') || 'грузовые',

      transportDescriptions: (newCar && 'грузовики') || 'грузовик',
      transportNextDescriptions: (newCar && 'грузовик') || 'грузовики',

      transportHeader: (newCar && 'новый грузовик') || 'грузовик',
      plural: (newCar && 'новые грузовики') || 'грузовики',
      pluralGenitive: (newCar && 'новых грузовиков') || 'грузовиков',
    },
    uk: {
      transportTitle: (newCar && 'вантажівку') || 'вантажівку',
      transportNextTitle: (newCar && 'вантажні') || 'вантажні',

      transportDescriptions: (newCar && 'вантажівки') || 'вантажівок',
      transportNextDescriptions: (newCar && 'вантажівку') || 'вантажівку',

      transportHeader: (newCar && 'нову вантажівку') || 'вантажівку',
      plural: (newCar && 'нові вантажівки') || 'вантажівки',
      pluralGenitive: (newCar && 'нових вантажівок') || 'вантажівок',
    },
  },
  Автобусы: {
    ru: {
      transportTitle: (newCar && 'автобус') || 'автобус',
      transportNextTitle: (newCar && '') || '',

      transportDescriptions: (newCar && 'автобусы') || 'автобус',
      transportNextDescriptions: (newCar && '') || '',

      transportHeader: (newCar && 'новый автобус') || 'автобус',
    },
    uk: {
      transportTitle: (newCar && 'автобус') || 'автобус',
      transportNextTitle: (newCar && '') || '',

      transportDescriptions: (newCar && 'автобусів') || 'автобусів',
      transportNextDescriptions: (newCar && '') || '',

      transportHeader: (newCar && 'новий автобус') || 'автобус',
    },
  },
  Прицепы: {
    ru: {
      transportTitle: (newCar && 'автоприцеп') || 'автоприцеп',
      transportNextTitle: (newCar && 'автоприцепы') || 'автоприцепы',

      transportDescriptions: (newCar && 'автоприцепов') || 'автоприцепов',
      transportNextDescriptions: (newCar && 'автоприцеп') || 'автоприцеп',

      transportHeader: (newCar && 'новый автоприцеп') || 'автоприцеп',
    },
    uk: {
      transportTitle: (newCar && 'автопричепи') || 'автопричепи',
      transportNextTitle: (newCar && 'автопричепи') || 'автопричепи',

      transportDescriptions: (newCar && 'причепів') || 'причепів',
      transportNextDescriptions: (newCar && 'причіп') || 'причіп',

      transportHeader: (newCar && 'новий причіп') || 'причіп',
    },
  },
  Спецтехника: {
    ru: {
      transportTitle: (newCar && 'спецтехнику') || 'спецтехнику',
      transportNextTitle: (newCar && 'специальная техника') || 'специальная техника',

      transportDescriptions: (newCar && 'спецтехнику') || 'спецтехнику',
      transportNextDescriptions:
        (newCar && 'Строительная, сельскохозяйственная, дорожная техника') ||
        'Строительная, сельскохозяйственная, дорожная техника',

      transportHeader: (newCar && 'новую спецтехнику') || 'спецтехнику',
    },
    uk: {
      transportTitle: (newCar && 'спецтехніку') || 'спецтехніку',
      transportNextTitle: (newCar && 'спеціальна техніка') || 'спеціальна техніка',

      transportDescriptions: (newCar && 'спецтехніки') || 'спецтехніки',
      transportNextDescriptions:
        (newCar && 'Будівельна, сільськогосподарська, дорожня техніка') ||
        'Будівельна, сільськогосподарська, дорожня техніка',

      transportHeader: (newCar && 'нову спецтехніку') || 'спецтехніку',
    },
  },
  'Водный транспорт': {
    ru: {
      transportTitle: (newCar && 'водный транспорт') || 'водный транспорт',
      transportNextTitle: (newCar && 'водный транспорт') || 'водный транспорт',

      transportDescriptions: (newCar && 'водный транспорт') || 'водный транспорт',
      transportNextDescriptions: '',

      transportHeader: (newCar && 'новый водный транспорт') || 'водный транспорт',
    },
    uk: {
      transportTitle: (newCar && 'водний транспорт') || 'водний транспорт',
      transportNextTitle: '',

      transportDescriptions: (newCar && 'водних транспортів') || 'водного транспорту',
      transportNextDescriptions: '',

      transportHeader: (newCar && 'новий водний транспорт') || 'водний транспорт',
    },
  },

  /* START TYPES OF GRUZOVYE */

  Автоцистерна: {
    ru: {
      transportHeader: (newCar && 'новую автоцистерну') || 'автоцистерну',
      pluralTransport: (newCar && 'новые автоцистерны') || 'автоцистерны',
      pluralGenericTransport: (newCar && 'новых автоцистерн') || 'автоцистерн',
    },
    uk: {
      transportHeader: (newCar && 'нову автоцистерну') || 'автоцистерну',
      pluralTransport: (newCar && 'нові автоцистерни') || 'автоцистерни',
      pluralGenericTransport: (newCar && 'нових автоцистерн') || 'автоцистерн',
    },
  },
  Автовоз: {
    ru: {
      transportHeader: (newCar && 'новый автовоз') || 'автовоз',
      pluralTransport: (newCar && 'новые автовозы') || 'автоцистерны',
      pluralGenericTransport: (newCar && 'новых автовозов') || 'автовозов',
    },
    uk: {
      transportHeader: (newCar && 'новий автовоз') || 'автовоз',
      pluralTransport: (newCar && 'нові автовози') || 'автовози',
      pluralGenericTransport: (newCar && 'нових автовозів') || 'автовозів',
    },
  },
  Зерновоз: {
    ru: {
      transportHeader: (newCar && 'новый зерновоз') || 'зерновоз',
      pluralTransport: (newCar && 'новые зерновозы') || 'зерновозы',
      pluralGenitiveTransport: (newCar && 'новых зерновозов') || 'зерновозов',
    },
    uk: {
      transportHeader: (newCar && 'новий зерновоз') || 'зерновоз',
      pluralTransport: (newCar && 'нові зерновози') || 'зерновози',
      pluralGenitiveTransport: (newCar && 'нових зерновозів') || 'зерновозів',
    },
  },
  Бортовой: {
    ru: {
      transportHeader: (newCar && 'новый бортовой грузовик') || 'бортовой грузовик',
      pluralTransport: (newCar && 'новые бортовые грузовики') || 'бортовые грузовики',
      pluralGenitiveTransport: (newCar && 'новых бортовых грузовиков') || 'бортовых грузовиков',
    },
    uk: {
      transportHeader: (newCar && 'нову бортову вантажівку') || 'бортову вантажівку',
      pluralTransport: (newCar && 'нові бортові вантажівки') || 'бортові вантажівки',
      pluralGenitiveTransport: (newCar && 'нових бортових вантажівок') || 'бортових вантажівок',
    },
  },
  Изотермо: {
    ru: {
      transportHeader: (newCar && 'новый изотерм грузовик') || 'изотерм грузовик',
      pluralTransport: (newCar && 'новые изотерм грузовики') || 'изотерм грузовики',
      pluralGenitiveTransport: (newCar && 'новых изотерм грузовиков') || 'изотерм грузовиков',
    },
    uk: {
      transportHeader: (newCar && 'нову ізотерм вантажівку') || 'ізотерм вантажівку',
      pluralTransport: (newCar && 'нові ізотерм вантажівки') || 'ізотерм вантажівки',
      pluralGenitiveTransport: (newCar && 'нових ізотерм вантажівок') || 'ізотерм вантажівок',
    },
  },
  Контейнеровоз: {
    ru: {
      transportHeader: (newCar && 'новый контейнеровоз') || 'контейнеровоз',
      pluralTransport: (newCar && 'новые контейнеровозы') || 'контейнеровозы',
      pluralGenitiveTransport: (newCar && 'новых контейнеровозов') || 'контейнеровозов',
    },
    uk: {
      transportHeader: (newCar && 'новий контейнеровоз') || 'контейнеровоз',
      pluralTransport: (newCar && 'нові контейнеровози') || 'контейнеровози',
      pluralGenitiveTransport: (newCar && 'нових контейнеровозів') || 'контейнеровозів',
    },
  },
  'Развозчик напитков': {
    ru: {
      transportHeader: (newCar && 'новый развозчик напитков') || 'развозчик напитков',
      pluralTransport: (newCar && 'новые развозчики напитков') || 'развозчики напитков',
      pluralGenitiveTransport: (newCar && 'новых развозчиков напитков') || 'развозчиков напитков',
    },
    uk: {
      transportHeader: (newCar && 'новий розвізник напоїв') || 'розвізник напоїв',
      pluralTransport: (newCar && 'нові розвізники напоїв') || 'розвізники напоїв',
      pluralGenitiveTransport: (newCar && 'нових розвізників напоїв') || 'розвізників напоїв',
    },
  },
  'Мебельный фургон': {
    ru: {
      transportHeader: (newCar && 'новый мебельный фургон') || 'мебельный фургон',
      pluralTransport: (newCar && 'новые мебельные фургоны') || 'мебельные фургоны',
      pluralGenitiveTransport: (newCar && 'новых мебельных фургонов') || 'мебельных фургонов',
    },
    uk: {
      transportHeader: (newCar && 'новий меблевий фургон') || 'меблевий фургон',
      pluralTransport: (newCar && 'нові меблеві фургони') || 'меблеві фургони',
      pluralGenitiveTransport: (newCar && 'нових меблевих фургонів') || 'меблевих фургонів',
    },
  },
  'Почтовый фургон': {
    ru: {
      transportHeader: (newCar && 'новый почтовый фургон') || 'почтовый фургон',
      pluralTransport: (newCar && 'новые почтовые фургоны') || 'почтовые фургоны',
      pluralGenitiveTransport: (newCar && 'новых почтовых фургонов') || 'почтовых фургонов',
    },
    uk: {
      transportHeader: (newCar && 'новий поштовий фургон') || 'поштовий фургон',
      pluralTransport: (newCar && 'нові поштові фургони') || 'поштові фургони',
      pluralGenitiveTransport: (newCar && 'нових поштових фургонів') || 'поштових фургонів',
    },
  },
  Рефрижератор: {
    ru: {
      transportHeader: (newCar && 'новый грузовик рефрижератор') || 'грузовик рефрижератор',
      pluralTransport: (newCar && 'новые грузовики рефрижераторы') || 'грузовики рефрижераторы',
      pluralGenitiveTransport: (newCar && 'новых грузовиков рефрижераторов') || 'грузовиков рефрижераторов',
    },
    uk: {
      transportHeader: (newCar && 'новий вантажівку рефрижератор') || 'вантажівку рефрижератор',
      pluralTransport: (newCar && 'нові вантажівки рефрижератори') || 'вантажівки рефрижератори',
      pluralGenitiveTransport: (newCar && 'нових вантажівок рефрижераторів') || 'вантажівок рефрижераторів',
    },
  },
  'Промтоварный фургон': {
    ru: {
      transportHeader: (newCar && 'новый промтоварный фургон') || 'промтоварный фургон',
      pluralTransport: (newCar && 'новые промтоварные фургоны') || 'промтоварные фургоны',
      pluralGenitiveTransport: (newCar && 'новых промтоварных фургонов') || 'промтоварных фургонов',
    },
    uk: {
      transportHeader: (newCar && 'новий промтоварний фургон') || 'промтоварний фургон',
      pluralTransport: (newCar && 'нові промтоварні фургони') || 'промтоварні фургони',
      pluralGenitiveTransport: (newCar && 'нових промтоварних фургонів') || 'промтоварних фургонів',
    },
  },
  Самосвал: {
    ru: {
      transportHeader: (newCar && 'новый самосвал') || 'самосвал',
      pluralTransport: (newCar && 'новые самосвалы') || 'самосвалы',
      pluralGenitiveTransport: (newCar && 'новых самосвалов') || 'самосвалов',
    },
    uk: {
      transportHeader: (newCar && 'новий самоскид') || 'самоскид',
      pluralTransport: (newCar && 'нові самоскиди') || 'самоскиди',
      pluralGenitiveTransport: (newCar && 'нових самоскидів') || 'самоскидів',
    },
  },
  Тент: {
    ru: {
      transportHeader: (newCar && 'новый тент') || 'тент',
      pluralTransport: (newCar && 'новые тенты') || 'тенты',
      pluralGenitiveTransport: (newCar && 'новых тентов') || 'тентов',
    },
    uk: {
      transportHeader: (newCar && 'новий тент') || 'тент',
      pluralTransport: (newCar && 'нові тенти') || 'тенти',
      pluralGenitiveTransport: (newCar && 'нових тентів') || 'тентів',
    },
  },
  Тягач: {
    ru: {
      transportHeader: (newCar && 'новый тягач') || 'тягач',
      pluralTransport: (newCar && 'новые тягачи') || 'тягачи',
      pluralGenitiveTransport: (newCar && 'новых тягачей') || 'тягачей',
    },
    uk: {
      transportHeader: (newCar && 'новий тягач') || 'тягач',
      pluralTransport: (newCar && 'нові тягачі') || 'тягачі',
      pluralGenitiveTransport: (newCar && 'нових тягачів') || 'тягачів',
    },
  },
  'Хлебный фургон': {
    ru: {
      transportHeader: (newCar && 'новый хлебный фургон') || 'хлебный фургон',
      pluralTransport: (newCar && 'новые хлебные фургоны') || 'хлебные фургоны',
      pluralGenitiveTransport: (newCar && 'новых хлебных фургонов') || 'хлебных фургонов',
    },
    uk: {
      transportHeader: (newCar && 'новий хлібний фургон') || 'хлібний фургон',
      pluralTransport: (newCar && 'нові хлібні фургони') || 'хлібні фургони',
      pluralGenitiveTransport: (newCar && 'нових хлібних фургонів') || 'хлібних фургонів',
    },
  },
  Шасси: {
    ru: {
      transportHeader: (newCar && 'новое шасси') || 'шасси',
      pluralTransport: (newCar && 'новые шасси') || 'шасси',
      pluralGenitiveTransport: (newCar && 'новых шасси') || 'шасси',
    },
    uk: {
      transportHeader: (newCar && 'нове шасі') || 'шасі',
      pluralTransport: (newCar && 'нові шасі') || 'шасі',
      pluralGenitiveTransport: (newCar && 'нових шасі') || 'шасі',
    },
  },
  Эвакуатор: {
    ru: {
      transportHeader: (newCar && 'новый эвакуатор') || 'эвакуатор',
      pluralTransport: (newCar && 'новые эвакуаторы') || 'эвакуаторы',
      pluralGenitiveTransport: (newCar && 'новых эвакуаторов') || 'эвакуаторов',
    },
    uk: {
      transportHeader: (newCar && 'новий евакуатор') || 'евакуатор',
      pluralTransport: (newCar && 'нові евакуатори') || 'евакуатори',
      pluralGenitiveTransport: (newCar && 'нових евакуаторів') || 'евакуаторів',
    },
  },

  /* END TYPES OF GRUZOVYE */

  /* START TYPES OF AVTOBUS */

  'Грузо-пасс.': {
    ru: {
      transportHeader: (newCar && 'новый грузопассажирский автобус') || 'грузопассажирский автобус',
      pluralTransport: 'грузо-пассажирские',
    },
    uk: {
      transportHeader:
        (newCar && 'новий вантажопасажирський автобус') || 'вантажопасажирський автобус',
      pluralTransport: 'вантажо-пасажирські',
    },
  },
  Грузовой: {
    ru: {
      transportHeader: (newCar && 'новый грузовой автобус') || 'грузовой автобус',
      pluralTransport: 'грузовые',
    },
    uk: {
      transportHeader: (newCar && 'новий вантажний автобус') || 'вантажний автобус',
      pluralTransport: 'вантажні',
    },
  },
  Пассажирский: {
    ru: {
      transportHeader: (newCar && 'новый пассажирский автобус') || 'пассажирский автобус',
      pluralTransport: 'пассажирские',
    },
    uk: {
      transportHeader: (newCar && 'новий пасажирський автобус') || 'пасажирський автобус',
      pluralTransport: 'пасажирські',
    },
  },

  /* END TYPES OF AVTOBUS */

  /* START TYPES OF PRITSEPY */

  Контейнер: {
    ru: {
      transportHeader: (newCar && 'новый контейнер') || 'контейнер',
      transportCategoryTitle: 'Прицеп контейнер',
    },
    uk: {
      transportHeader: (newCar && 'новий контейнер') || 'контейнер',
      transportCategoryTitle: 'Причіп контейнер',
    },
  },
  Будка: {
    ru: {
      transportHeader: (newCar && 'новый будка') || 'будка',
      transportCategoryTitle: 'Прицеп будка',
    },
    uk: {
      transportHeader: (newCar && 'нову будку') || 'будку',
      transportCategoryTitle: 'Причіп будка',
    },
  },
  Полуприцеп: {
    ru: {
      transportHeader: (newCar && 'новый полуприцеп') || 'полуприцеп',
    },
    uk: {
      transportHeader: (newCar && 'новий напівпричіп') || 'напівпричіп',
    },
  },
  Прицеп: {
    ru: {
      transportHeader: (newCar && 'новый прицеп') || 'прицеп',
    },
    uk: {
      transportHeader: (newCar && 'новий причіп') || 'причіп',
    },
  },
  Дача: {
    ru: {
      transportHeader: (newCar && 'новый дача') || 'дача',
    },
    uk: {
      transportHeader: (newCar && 'нову дачу') || 'дачу',
    },
  },

  /* END TYPES OF PRITSEPY */

  /* START TYPES OF VODNYI-TRANSPORT */

  Гидроцикл: {
    ru: {
      transportHeader: (newCar && 'новый гидроцикл') || 'гидроцикл',
      transportCategoryTitle: 'Гидроцикл',
    },
    uk: {
      transportHeader: (newCar && 'новий гідроцикл') || 'гідроцикл',
      transportCategoryTitle: 'Гідроцикл',
    },
  },
  Катер: {
    ru: {
      transportHeader: (newCar && 'новый катер') || 'катер',
      transportCategoryTitle: 'Катер',
    },
    uk: {
      transportHeader: (newCar && 'новий катер') || 'катер',
      transportCategoryTitle: 'Катер',
    },
  },
  Лодка: {
    ru: {
      transportHeader: (newCar && 'новую лодку') || 'лодку',
      transportCategoryTitle: 'Лодка',
    },
    uk: {
      transportHeader: (newCar && 'новий човен') || 'човен',
      transportCategoryTitle: 'Човен',
    },
  },
  Яхта: {
    ru: {
      transportHeader: (newCar && 'новую яхту') || 'яхту',
      transportCategoryTitle: 'Яхта',
    },
    uk: {
      transportHeader: (newCar && 'нову яхту') || 'яхту',
      transportCategoryTitle: 'Яхта',
    },
  },
  Дебаркадер: {
    ru: {
      transportHeader: (newCar && 'новый дебаркадер') || 'дебаркадер',
      transportCategoryTitle: 'Дебаркадер',
    },
    uk: {
      transportHeader: (newCar && 'новий дебаркадер') || 'дебаркадер',
      transportCategoryTitle: 'Дебаркадер',
    },
  },
  Катамаран: {
    ru: {
      transportHeader: (newCar && 'новый катамаран') || 'катамаран',
      transportCategoryTitle: 'Катамаран',
    },
    uk: {
      transportHeader: (newCar && 'новий катамаран') || 'катамаран',
      transportCategoryTitle: 'Катамаран',
    },
  },
  'Плав-дача': {
    ru: {
      transportHeader: (newCar && 'новую плав-дачу') || 'плав-дачу',
      transportCategoryTitle: 'Плав-дача',
    },
    uk: {
      transportHeader: (newCar && 'нову плав-дачу') || 'плав-дачу',
      transportCategoryTitle: 'Плав-дача',
    },
  },
  Теплоход: {
    ru: {
      transportHeader: (newCar && 'новый теплоход') || 'теплоход',
      transportCategoryTitle: 'Теплоход',
    },
    uk: {
      transportHeader: (newCar && 'новий теплохід') || 'теплохід',
      transportCategoryTitle: 'Теплохід',
    },
  },
  'Хауз-бот': {
    ru: {
      transportHeader: (newCar && 'новый хауз-бот') || 'хауз-бот',
      transportCategoryTitle: 'Хауз-бот',
    },
    uk: {
      transportHeader: (newCar && 'новий хауз-бот') || 'хауз-бот',
      transportCategoryTitle: 'Хауз-бот',
    },
  },
  'Лодочный двигатель': {
    ru: {
      transportHeader: (newCar && 'новый лодочный двигатель') || 'лодочный двигатель',
      transportCategoryTitle: 'Лодочный двигатель',
    },
    uk: {
      transportHeader: (newCar && 'новий човновий двигун') || 'човновий двигун',
      transportCategoryTitle: 'Човновий двигун',
    },
  },
  'Прицеп для водного транспорта': {
    ru: {
      transportHeader:
        (newCar && 'новый прицеп для водного транспорта') || 'прицеп для водного транспорта',
      transportCategoryTitle: 'Прицеп для водного транспорта',
    },
    uk: {
      transportHeader:
        (newCar && 'новий причіп для водного транспорту') || 'причіп для водного транспорту',
      transportCategoryTitle: 'Причіп для водного транспорту',
    },
  },
  'Развлечения на воде': {
    ru: {
      transportHeader: (newCar && 'новые развлечения на воде') || 'развлечения на воде',
      transportCategoryTitle: 'Развлечения на воде',
    },
    uk: {
      transportHeader: (newCar && 'нові розваги на воді') || 'розваги на воді',
      transportCategoryTitle: 'Розваги на воді',
    },
  },

  /* END TYPES OF VODNYI-TRANSPORT */

  /* START TYPES OF SPETSTEHNIKA */

  'Электростанция / Генератор': {
    ru: {
      transportHeader:
        (newCar && 'новую электростанцию / генератор') || 'электростанцию / генератор',
      transportCategoryTitle: 'Электростанции / Генераторы',
    },
    uk: {
      transportHeader:
        (newCar && 'нову електростанцію / генератор') || 'електростанція / генератор',
      transportCategoryTitle: 'Електростанції / Генератои',
    },
  },
  Строительная: {
    ru: {
      transportHeader: (newCar && 'новую строительную технику') || 'строительную технику',
      transportCategoryTitle: 'Строительная техника',
    },
    uk: {
      transportHeader: (newCar && 'нову будівельну техніку') || 'будівельну техніку',
      transportCategoryTitle: 'Будівельна техніка',
    },
  },
  Автовышка: {
    ru: {
      transportHeader: (newCar && 'новую автовышку') || 'автовышку',
      transportCategoryTitle: 'Автовышки',
    },
    uk: {
      transportHeader: (newCar && 'нову автовишку') || 'автовишку',
      transportCategoryTitle: 'Автовишки',
    },
  },
  Бетоносмеситель: {
    ru: {
      transportHeader: (newCar && 'новый бетоносмеситель') || 'бетоносмеситель',
      transportCategoryTitle: 'Бетоносмесители',
    },
    uk: {
      transportHeader: (newCar && 'новий бетонозмішувач') || 'бетонозмішувач',
      transportCategoryTitle: 'Бетонозмішувачі',
    },
  },
  Бензовоз: {
    ru: {
      transportHeader: (newCar && 'новый бензовоз') || 'бензовоз',
      transportCategoryTitle: 'Бензовозы',
    },
    uk: {
      transportHeader: (newCar && 'новий бензовоз') || 'бензовоз',
      transportCategoryTitle: 'Бензовози',
    },
  },
  Бульдозер: {
    ru: {
      transportHeader: (newCar && 'новый бульдозер') || 'бульдозер',
      transportCategoryTitle: 'Бульдозеры',
    },
    uk: {
      transportHeader: (newCar && 'новий бульдозер') || 'бульдозер',
      transportCategoryTitle: 'Бульдозери',
    },
  },
  Бетононасос: {
    ru: {
      transportHeader: (newCar && 'новый бетононасос') || 'бетононасос',
      transportCategoryTitle: 'Бетононасосы',
    },
    uk: {
      transportHeader: (newCar && 'новий бетононасос') || 'бетононасос',
      transportCategoryTitle: 'Бетононасоси',
    },
  },
  'Буровые установки': {
    ru: {
      transportHeader: (newCar && 'новые буровые установки') || 'буровые установки',
      transportCategoryTitle: 'Буровые установки',
    },
    uk: {
      transportHeader: (newCar && 'нові бурові установки') || 'бурові установки',
      transportCategoryTitle: 'Бурові установки',
    },
  },
  'Дорожная техника': {
    ru: {
      transportHeader: (newCar && 'новую дорожную технику') || 'дорожную технику',
      transportCategoryTitle: 'Дорожная техника',
    },
    uk: {
      transportHeader: (newCar && 'нову дорожню техніку') || 'дорожню техніку',
      transportCategoryTitle: 'Дорожня техніка',
    },
  },
  Экскаватор: {
    ru: {
      transportHeader: (newCar && 'новый экскаватор') || 'экскаватор',
      transportCategoryTitle: 'Экскаваторы',
    },
    uk: {
      transportHeader: (newCar && 'новий екскаватор') || 'екскаватор',
      transportCategoryTitle: 'Екскаватори',
    },
  },
  'Екскаватор погрузчик': {
    ru: {
      transportHeader: (newCar && 'новый экскаватор погрузчик') || 'экскаватор погрузчик',
      transportCategoryTitle: 'Екскаваторы погрузчикы',
    },
    uk: {
      transportHeader: (newCar && 'новий екскаватор навантажувач') || 'екскаватор навантажувач',
      transportCategoryTitle: 'Екскаватори навантажувачі',
    },
  },
  'Коммунальная техника': {
    ru: {
      transportHeader: (newCar && 'новую коммунальную технику') || 'коммунальную технику',
      transportCategoryTitle: 'Коммунальные техники',
    },
    uk: {
      transportHeader: (newCar && 'нову комунальну техніку') || 'комунальну техніку',
      transportCategoryTitle: 'Комунальна техніка',
    },
  },
  Кран: {
    ru: {
      transportHeader: (newCar && 'новый кран') || 'кран',
      transportCategoryTitle: 'Краны',
    },
    uk: {
      transportHeader: (newCar && 'новий кран') || 'кран',
      transportCategoryTitle: 'Крани',
    },
  },
  'Машина для разбрасывания': {
    ru: {
      transportHeader: (newCar && 'новую машину для разбрасывания') || 'машину для разбрасывания',
      transportCategoryTitle: 'Машины для разбрасывания',
    },
    uk: {
      transportHeader: (newCar && 'нову машину для розкидання') || 'машину для розкидання',
      transportCategoryTitle: 'Машини для розкидання',
    },
  },
  Минитрактор: {
    ru: {
      transportHeader: (newCar && 'новый минитрактор') || 'минитрактор',
      transportCategoryTitle: 'Минитракторы',
    },
    uk: {
      transportHeader: (newCar && 'новий мінітрактор') || 'мінітрактор',
      transportCategoryTitle: 'Мінітрактори',
    },
  },
  Мотоблок: {
    ru: {
      transportHeader: (newCar && 'новый мотоблок') || 'мотоблок',
      transportCategoryTitle: 'Мотоблоки',
    },
    uk: {
      transportHeader: (newCar && 'новий мотоблок') || 'мотоблок',
      transportCategoryTitle: 'Мотоблоки',
    },
  },
  Погрузчик: {
    ru: {
      transportHeader: (newCar && 'новый погрузчик') || 'погрузчик',
      transportCategoryTitle: 'Погрузчики',
    },
    uk: {
      transportHeader: (newCar && 'новий навантажувач') || 'навантажувач',
      transportCategoryTitle: 'Навантажувачі',
    },
  },
  Спецавтомобили: {
    ru: {
      transportHeader: (newCar && 'новые спецавтомобили') || 'спецавтомобили',
      transportCategoryTitle: 'Спецавтомобили',
    },
    uk: {
      transportHeader: (newCar && 'нові спецавтомобілі') || 'спецавтомобілі',
      transportCategoryTitle: 'Спецавтомобілі',
    },
  },
  Трактор: {
    ru: {
      transportHeader: (newCar && 'новый трактор') || 'трактор',
      transportCategoryTitle: 'Тракторы',
    },
    uk: {
      transportHeader: (newCar && 'новий трактор') || 'трактор',
      transportCategoryTitle: 'Трактори',
    },
  },
  Подъемник: {
    ru: {
      transportHeader: (newCar && 'новый подъемник') || 'подъемник',
      transportCategoryTitle: 'Подъемники',
    },
    uk: {
      transportHeader: (newCar && 'новий підйомник') || 'підйомник',
      transportCategoryTitle: 'Підйомники',
    },
  },
  Сельхозтехника: {
    ru: {
      transportHeader: (newCar && 'новую сельхозтехнику') || 'сельхозтехнику',
      transportCategoryTitle: 'Сельхозтехника',
    },
    uk: {
      transportHeader: (newCar && 'нову сільгосптехніку') || 'сільгосптехніку',
      transportCategoryTitle: 'Сільгосптехніка',
    },
  },
  /* END TYPES OF SPETSTEHNIKA */

  /* END TYPES OF MOTO-TRANSPORT */
  Мотоциклы: {
    ru: {
      motoHeader: (newCar && 'новый мотоцикл') || 'мотоцикл',
      motoTitle: (newCar && 'новый мотоцикл') || 'мотоцикл',
    },
    uk: {
      motoHeader: (newCar && 'новий мотоцикл') || 'мотоцикл',
      motoTitle: (newCar && 'новий мотоцикл') || 'мотоцикл',
    },
  },
  Классик: {
    ru: {
      motoHeader: (newCar && 'новый мотоцикл классик') || 'мотоцикл классик',
      motoTitle: (newCar && 'новый мотоцикл классик') || 'мотоцикл классик',
    },
    uk: {
      motoHeader: (newCar && 'новий мотоцикл классік') || 'мотоцикл классік',
      motoTitle: (newCar && 'новий мотоцикл классік') || 'мотоцикл классік',
    },
  },
  'Круизер / Чоппер': {
    ru: {
      motoHeader: (newCar && 'новый круизер / чоппер') || 'круизер / чоппер',
      motoTitle: (newCar && 'новый круизер / чопер') || 'круизер / чопер',
    },
    uk: {
      motoHeader: (newCar && 'новий круїзер / чоппер') || 'круїзер / чоппер',
      motoTitle: (newCar && 'новий круїзер / чоппер') || 'круїзер / чоппер',
    },
  },
  'Эндуро / Кросс': {
    ru: {
      motoHeader: (newCar && 'новый мотоцикл эндуро / кросс') || 'мотоцикл эндуро / кросс',
      motoTitle: (newCar && 'новый мотоцикл эндуро / кросс') || 'мотоцикл эндуро / кросс',
    },
    uk: {
      motoHeader: (newCar && 'новий мотоцикл ендуро / крос') || 'мотоцикл ендуро / крос',
      motoTitle: (newCar && 'новий мотоцикл ендуро / крос') || 'мотоцикл ендуро / крос',
    },
  },
  Спорт: {
    ru: {
      motoHeader: (newCar && 'новый спортивный мотоцикл') || 'спортивный мотоцикл',
      motoTitle: (newCar && 'новый спортивный мотоцикл') || 'спортивный мотоцикл',
    },
    uk: {
      motoHeader: (newCar && 'новий спортивний мотоцикл') || 'спортивний мотоцикл',
      motoTitle: (newCar && 'новий спортивний мотоцикл') || 'спортивний мотоцикл',
    },
  },
  Трайк: {
    ru: {
      motoHeader: (newCar && 'новый трайк') || 'трайк',
      motoTitle: (newCar && 'новый трайк') || 'трайк',
    },
    uk: {
      motoHeader: (newCar && 'новий трайк') || 'трайк',
      motoTitle: (newCar && 'новий трайк') || 'трайк',
    },
  },
  Турист: {
    ru: {
      motoHeader: (newCar && 'новый мотоцикл турист') || 'мотоцикл турист',
      motoTitle: (newCar && 'новый мотоцикл турист') || 'мотоцикл турист',
    },
    uk: {
      motoHeader: (newCar && 'новий мотоцикл турист') || 'мотоцикл турист',
      motoTitle: (newCar && 'новий мотоцикл турист') || 'мотоцикл турист',
    },
  },
  Спортивный: {
    ru: {
      motoHeader: (newCar && 'новый спортивный квадроцикл') || 'спортивный квадроцикл',
      motoTitle: (newCar && 'новый спортивный квадроцикл') || 'спортивный квадроцикл',
    },
    uk: {
      motoHeader: (newCar && 'новий спортивний квадроцикл') || 'спортивний квадроцикл',
      motoTitle: (newCar && 'новий спортивний квадроцикл') || 'спортивний квадроцикл',
    },
  },
  Утилитарный: {
    ru: {
      motoHeader: (newCar && 'новый утилитарный квадроцикл') || 'утилитарный квадроцикл',
      motoTitle: (newCar && 'новый утилитарный квадроцикл') || 'утилитарный квадроцикл',
    },
    uk: {
      motoHeader: (newCar && 'новий утилітарний квадроцикл') || 'утилітарний квадроцикл',
      motoTitle: (newCar && 'новий утилітарний квадроцикл') || 'утилітарний квадроцикл',
    },
  },
  /* START TYPES OF MOTO-TRANSPORT  */
});
// noinspection NonAsciiCharacters
export const rubrics = {
  Двигатель: {
    ru: { nominative: 'Двигатель', accusative: 'Двигателя' },
    uk: { nominative: 'Двигун', accusative: 'Двигуна' },
  },
  'Дополнительное оборудование': {
    ru: { nominative: 'Дополнительное оборудование', accusative: 'Дополнительного оборудования' },
    uk: { nominative: 'Додаткове обладнання', accusative: 'Додаткового обладнання' },
  },
  Кузов: {
    ru: { nominative: 'Кузов', accusative: 'Кузова' },
    uk: { nominative: 'Кузов', accusative: 'Кузова' },
  },
  'Оптика, стекло, зеркала': {
    ru: { nominative: 'Оптика, стекло, зеркала', accusative: 'Оптики, стекла, зеркал' },
    uk: { nominative: 'Оптика, скло, дзеркала', accusative: 'Оптики, скла, дзеркал' },
  },
  'Отопление и кондиционирование': {
    ru: {
      nominative: 'Отопление и кондиционирование',
      accusative: 'Отопления и кондиционирования',
    },
    uk: { nominative: 'Опалення та кондиціонування', accusative: 'Опалення та кондиціонування' },
  },
  'Очистители стекла и фар': {
    ru: { nominative: 'Очистители стекла и фар', accusative: 'Очистителей стекла и фар' },
    uk: { nominative: 'Очищувачі скла і фар', accusative: 'Очищувачів скла і фар' },
  },
  'Прицепное оборудование': {
    ru: { nominative: 'Прицепное оборудование', accusative: 'Прицепного оборудования' },
    uk: { nominative: 'Причіпне обладнання', accusative: 'Причіпного обладнання' },
  },
  Разборка: {
    ru: { nominative: 'Разборка', accusative: 'Разборки' },
    uk: { nominative: 'Розбірка', accusative: 'Розбірки' },
  },
  'Рулевое управление': {
    ru: { nominative: 'Рулевое управление', accusative: 'Рулевого управления' },
    uk: { nominative: 'Рульове управління', accusative: 'Рульового управління' },
  },
  Салон: {
    ru: { nominative: 'Салон', accusative: 'Салона' },
    uk: { nominative: 'Салон', accusative: 'Салону' },
  },
  'Система безопасности': {
    ru: { nominative: 'Система безопасности', accusative: 'Системы безопасности' },
    uk: { nominative: 'Система безпеки', accusative: 'Системи безпеки' },
  },
  'Система охлаждения': {
    ru: { nominative: 'Система охлаждения', accusative: 'Системы охлаждения' },
    uk: { nominative: 'Система охолодження', accusative: 'Системи охолодження' },
  },
  'Топливная система': {
    ru: { nominative: 'Топливная система', accusative: 'Топливной системы' },
    uk: { nominative: 'Паливна система', accusative: 'Паливної системи' },
  },
  'Тормозная система': {
    ru: { nominative: 'Тормозная система', accusative: 'Тормозной системы' },
    uk: { nominative: 'Гальмівна система', accusative: 'Гальмівної системи' },
  },
  Трансмиссия: {
    ru: { nominative: 'Трансмиссия', accusative: 'Трансмиссии' },
    uk: { nominative: 'Трансмісія', accusative: 'Трансмісії' },
  },
  Фильтры: {
    ru: { nominative: 'Фильтры', accusative: 'Фильтров' },
    uk: { nominative: 'Фільтри', accusative: 'Фільтрів' },
  },
  Ходовая: {
    ru: { nominative: 'Ходовая', accusative: 'Ходовой' },
    uk: { nominative: 'Ходова', accusative: 'Ходової' },
  },
  'Шины, диски': {
    ru: { nominative: 'Шины, диски', accusative: 'Шин, дисков' },
    uk: { nominative: 'Шини, диски', accusative: 'Шин, дисків' },
  },
  'Электрика и электроника': {
    ru: { nominative: 'Электрика и электроника', accusative: 'Электрики и электроники' },
    uk: { nominative: 'Електрика та електроніка', accusative: 'Електрики та електроніки' },
  },
};
// noinspection NonAsciiCharacters
export const gearboxes = {
  Автомат: {
    ru: {
      title: 'Автомат',
      altTitle: 'Автоматическая коробка',
    },
    uk: {
      title: 'Автомат',
      altTitle: 'Автоматична коробка',
    },
  },
  Механика: {
    ru: {
      title: 'Механика',
      altTitle: 'Механическая коробка',
    },
    uk: {
      title: 'Механіка',
      altTitle: 'Механічна коробка',
    },
  },
  Механіка: {
    uk: {
      title: 'Механіка',
      altTitle: 'Механічна коробка',
    },
  },
  Вариатор: {
    ru: {
      title: 'Вариатор',
      altTitle: 'Вариаторная коробка',
    },
    uk: {
      title: 'Варіатор',
      altTitle: 'Варіаторна коробка',
    },
  },
  Варіатор: {
    uk: {
      title: 'Варіатор',
      altTitle: 'Варіаторна коробка',
    },
  },
  Робот: {
    ru: {
      title: 'Робот',
      altTitle: 'Роботизированная коробка',
    },
    uk: {
      title: 'Робот',
      altTitle: 'Роботизована коробка',
    },
  },
};

// noinspection NonAsciiCharacters
export const engines = {
  Дизельный: {
    ru: {
      short: 'дизель',
      title: 'Автомобиль дизель',
      altTitle: 'Дизельные авто',
    },
    uk: {
      short: 'дизель',
      title: 'Авто дизель',
      altTitle: 'Дизельні авто',
    },
  },
  Дизельний: {
    uk: {
      short: 'дизель',
      title: 'Авто дизель',
      altTitle: 'Дизельні авто',
    },
  },
  Электрический: {
    ru: {
      short: 'электро',
      title: 'Электромобиль',
      altTitle: 'Электромобили',
    },
    uk: {
      short: 'электро',
      title: 'Электромобіль',
      altTitle: 'Электромобілі',
    },
  },
  Електричний: {
    uk: {
      short: 'электро',
      title: 'Электромобіль',
      altTitle: 'Электромобілі',
    },
  },
  Бензиновый: {
    ru: {
      short: 'бензин',
      title: 'Автомобиль бензин',
      altTitle: 'Бензиновые авто',
    },
    uk: {
      short: 'бензин',
      title: 'Авто бензин',
      altTitle: 'Бензиновые авто',
    },
  },
  Бензиновий: {
    uk: {
      short: 'бензин',
      title: 'Авто бензин',
      altTitle: 'Бензиновые авто',
    },
  },
  Гибридный: {
    ru: {
      short: 'гибрид',
      title: 'Гибрид',
      altTitle: 'Гибридные авто',
    },
    uk: {
      short: 'гібрид',
      title: 'Гібрид',
      altTitle: 'Гибридні авто',
    },
  },
  Гібридний: {
    uk: {
      short: 'гібрид',
      title: 'Гібрид',
      altTitle: 'Гибридні авто',
    },
  },
  Газ: {
    ru: {
      short: 'газ/бензин',
      title: 'Автомобиль газ/бензин',
      altTitle: 'Авто газ/бензин',
    },
    uk: {
      short: 'газ/бензин',
      title: 'Автомобиль газ/бензин',
      altTitle: 'Авто газ/бензин',
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared/modules/subjectiveText/allText.js